/* bj-shell.js — masthead clock + mobile menu for every page that is not the
   home page (home runs the same code inside bj-v3.js). 11 Sep 2026. */
(function () {
  'use strict';
  (function clock() {
    var els = document.querySelectorAll('[data-c-clock]');
    if (!els.length) return;
    var fmt, tzFmt;
    try {
      fmt = new Intl.DateTimeFormat('en-IE', {
        hour: '2-digit', minute: '2-digit', hour12: false,
        timeZone: 'Europe/Dublin'
      });
      tzFmt = new Intl.DateTimeFormat('en-IE', {
        timeZoneName: 'short', timeZone: 'Europe/Dublin'
      });
    } catch (e) { return; }
    var tick = function () {
      var t = fmt.format(new Date());
      // Dublin is IST only in summer — derive the abbreviation, never
      // hardcode it (GMT half the year; a wrong zone is an invented fact).
      var tz = '';
      try {
        var part = tzFmt.formatToParts(new Date()).find(function (p) { return p.type === 'timeZoneName'; });
        tz = part ? ' ' + part.value : '';
      } catch (e) {}
      els.forEach(function (el) { el.textContent = t + tz; });
    };
    tick();
    setInterval(tick, 30000);
  })();

  (function menu() {
    var burger = document.querySelector('.c-masthead__burger');
    var menu = document.getElementById('c-menu');
    if (!burger || !menu) return;
    var close = menu.querySelector('.c-menu__close');
    var setOpen = function (open) {
      document.body.classList.toggle('c-nav-open', open);
      menu.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      // The page behind the sheet goes inert (focus can't tab out of the
      // modal) and Lenis is stopped so it can't scroll underneath.
      ['main', '.c-footer', '.c-ticker'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) { if (open) el.setAttribute('inert', ''); else el.removeAttribute('inert'); }
      });
      if (window.__bj3Lenis) { open ? window.__bj3Lenis.stop() : window.__bj3Lenis.start(); }
      if (open) { menu.removeAttribute('inert'); menu.querySelector('a,button').focus(); }
      else { menu.setAttribute('inert', ''); burger.focus(); }
    };
    burger.addEventListener('click', function () { setOpen(!menu.classList.contains('is-open')); });
    if (close) close.addEventListener('click', function () { setOpen(false); });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false);
    });
  })();
})();
